import React, { useEffect, useState, useContext } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { useHistory } from 'react-router-dom';
import TopNav from 'components/TopNav';
import BottomNav from 'components/BottomNav';
import styles from './style.module.scss';
import ErrorMessage from 'common/error';
import * as profileApi from 'api/profile';
import { useQueryClient } from 'react-query';
import i18n from '../../../common/i18n';
import { EMAIL_REGEX } from '../../../config/constants';
import { AuthContext } from '../../../context/AuthContext';


function ChangeEmail() {
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [visible, setVisible] = useState(false);
  const [type, settype] = useState(0);
  const [messageErr, setMessageErr] = useState();
  const userProfile = authContext.userProfile

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        setVisible(false);
      }, 3000);
    }
  }, [visible]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setAlertMessage(ErrorMessage.validate_email_contact);
      return;
    }
    if (!EMAIL_REGEX.test(email)) {
      setAlertMessage(ErrorMessage.validate_email_contact_format);
      return;
    }

    const checkIsEmailExist = await profileApi.checkIsEmailExist(email);

    if (checkIsEmailExist.success === false) {
      setAlertMessage(checkIsEmailExist.message);
      return;
    }

    if (window.confirm('このメールアドレスに変更してよろしいですか？\n変更後、認証メールをお送りいたしますので、変更の認証を行って下さい')) {
      let result = email;
      let data = {
        memberId: userProfile.id,
        mailAddress: result,
      };
      try {
        await profileApi.createVerifyEmail(data);
        settype(1);
      } catch (e) {
        setAlertMessage(e.response?.data?.message);
      }
    }
  };

  const setAlertMessage = (message) => {
    setMessageErr(message);
    setVisible(true);
  };

  const handleCheckSendGridStatus = async() => {
    let result = userProfile?.emailAddressMain;
    let data = {
      memberId: userProfile.id,
      mailAddress: result,
    };
    try {
      await profileApi.checkStatusEmailSendGrid(data);
      settype(1);
    } catch (e) {
      setAlertMessage(e.response?.data?.message);
    }
  }

  return (
    <div style={{ overflow: 'auto', height: '100vh' }}>
      <div style={{ maxWidth: 560, margin: 'auto' }}>
        <TopNav name={`メールアドレス設定`} hasBackIcon={true} />
        <div className={`${styles.changePhone} align-top`}>
          <form onSubmit={handleSubmit}>
            <div className={styles.back_white_wrap}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className="align-center mb-heading">
                  <span className="stick-icon">&nbsp;</span>
                  <span className="title font-4">メールアドレスを登録変更する</span>
                </div>
              </div>
              <div>
                <span className="title font-3">
                  メールアドレス設定を行います。
                  <br/>
                  登録変更されたいメールアドレスを入力して下さい。
                </span>
              </div>
              <div className={styles.divInputOne}>
                <div className="d-flex">
                  <span className="font-2">現在のメールアドレス</span>
                  {!userProfile?.sendgridStatus &&
                    <span style={{ marginLeft: 20, color: 'red', fontSize: 11 }}>メールが不着です、メールアドレスが正しい場合は、こちらをクリックして確認メールをお受け取り下さい<span style={{cursor: 'pointer', marginLeft: 20, color: 'var(--text3)', fontSize: 11 }} onClick={handleCheckSendGridStatus}>認証メールを送る</span></span>}
                </div>
                <div style={{ justifyContent: 'flex-end' }} className={styles.infoRow}>
                  <span className="font-2">{userProfile.emailAddressMain ? userProfile.emailAddressMain : ''}</span>
                </div>

                <div className="d-flex space-between">
                  <span className="font-2">メールアドレス（正確にご入力下さい）</span>
                </div>
                <input
                  id="name"
                  type="text"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="新しいメールアドレスを入力してください"
                />
              </div>

              <br />
              <center>
                <div id="sign-in-button"></div>
              </center>
              <div className={styles.divSubmit}>
                <div className="btn-main btn-submit" onClick={handleSubmit}>
                  {i18n.contact_btn_send}
                </div>
              </div>
            </div>
          </form>
          {!!type && (
            <center>
              <p className="font-2">認証メールをお送りしました</p>
              <p className="font-2">認証メールが届かない場合は、入力されたメールアドレスをご確認頂き、再度「送信」ボタンをクリックして下さい</p>
            </center>
          )}

          <Dialog
            open={visible}
            onClose={() => setVisible(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            style={{ opacity: 0.6 }}
          >
            <DialogContent style={{ backgroundColor: 'var(--black)' }} onClick={() => setVisible(false)}>
              <span style={{ color: 'var(--white)', fontWeight: 'bold' }}>{messageErr}</span>
            </DialogContent>
          </Dialog>
        </div>
        <BottomNav />
      </div>
    </div>
  );
}

export default ChangeEmail;
